type QuestDisplayCandidate = {
    id?: string | number
    is_draft?: boolean
    localChildQuest?: boolean
    isLocalChildQuest?: boolean
    isLocalRootQuest?: boolean
    localPublishErrorStatus?: unknown
} | null

type ResolvePanelDisplayQuestArgs<TQuest extends QuestDisplayCandidate> = {
    quest: TQuest
    cachedQuest: TQuest
    isFetching: boolean
    isError: boolean
    questId?: string | number | null
}

export function isLocalCachedQuest(cachedQuest: QuestDisplayCandidate): boolean {
    return (
        !!cachedQuest?.is_draft ||
        !!cachedQuest?.localChildQuest ||
        !!cachedQuest?.isLocalChildQuest ||
        !!cachedQuest?.isLocalRootQuest ||
        !!cachedQuest?.localPublishErrorStatus
    )
}

export function resolvePanelDisplayQuest<TQuest extends QuestDisplayCandidate>({
    quest,
    cachedQuest,
    isFetching,
    isError,
    questId,
}: ResolvePanelDisplayQuestArgs<TQuest>): TQuest {
    if (quest?.id === '__PRIVATE__') return quest
    if (isLocalCachedQuest(cachedQuest)) return quest || cachedQuest
    if (questId && isFetching) return quest || cachedQuest
    if (questId && isError) return null as TQuest

    return quest || cachedQuest
}
